'use client'

import { cx } from 'classix'
import {
	IMAGE_ASPECT_RATIO,
	MIN_IMAGES_TO_SHOW,
} from 'pdp/src/components/Gallery/constants'
import { Video } from 'pdp/src/components/Gallery/Video/Video'
import { ZoomableImage } from 'pdp/src/components/Gallery/ZoomableImage/ZoomableImage'
import { dataTestIds } from 'pdp/src/constants/dataTestIds/dataTestIds'
import type { Media } from 'pdp/src/types/FullProduct'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import styles from './ImageGridItem.module.css'

export const ImageGridItem = ({
	mediaItem,
	index,
	viewWidth,
	className,
}: {
	readonly mediaItem: Media
	readonly index: number
	readonly viewWidth: string
	readonly className: string
}) => {
	const { isLessThanLarge } = useResponsive()

	return (
		<li className={cx(className, styles.imageItem)} key={mediaItem.type}>
			{mediaItem.format === 'IMAGE' ? (
				<ZoomableImage
					label={`Zoom Image ${index + 1}`}
					media={mediaItem}
					priority={!isLessThanLarge && index < MIN_IMAGES_TO_SHOW}
					className={styles.image}
					sizes={`(min-width: 1024px) ${viewWidth}`}
					height={1}
					width={IMAGE_ASPECT_RATIO}
					dataTestid={dataTestIds['pdp.gallery.image']}
				/>
			) : (
				<Video className={styles.image} url={mediaItem.src} />
			)}
		</li>
	)
}
